module.exports = __webpack_public_path__ + "assets/img/pop-mini-74b6686c.jpg";